import { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router";

import { isSamePage } from "../../helpers";
import { isFirefox } from "../../helpers/browser/isFirefox";

export const useScrollToTop = () => {
  const [oldPathname, setOldPathname] = useState<string>("");

  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior:
        isSamePage(pathname, oldPathname) && !isFirefox ? "smooth" : "auto",
    });
    setOldPathname(pathname);
  }, [pathname]);
};
